import { PipelineType } from '@nova/types';

import { BaseUniformData } from '../pipeline-base';
import { TexturePipelineBase } from '../pipeline-texBase';

import { ConvertToColourMatrixUniformData } from './pipeline-utils-colourMatrix';

export type RGBKeys = 'r' | 'g' | 'b';
export type AlphaKey = 'a';

export type rgbKeyValueSet = Record <RGBKeys, number>;
export type rgbaKeyValueSet = Record <AlphaKey, number> & rgbKeyValueSet;

export type MatrixTuple = [
  number, number, number, number,
  number, number, number, number,
  number, number, number, number,
  number, number, number, number
];

// These props should be in a completely pipeline-usable state.
export interface PipelineSeriesEntry_UniformParams {
  type: PipelineType;
  params: BaseUniformData;
}
export type PipelineSeriesToRender = PipelineSeriesEntry_UniformParams[];

export type TexturePipelineSet = { [pipelineEnumKey: string]: TexturePipelineBase };

/**
 * TODO: Leave notes
 */

export function ConvertToFloatList(rgbSet: rgbKeyValueSet): Float32List {
  return Object.values(rgbSet);
}

/**
 * TODO: Leave notes
 */

// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
export const pipelineSeriesParamConversion: { [key in PipelineType]?: Function } = {
  [PipelineType.tint]: ConvertToFloatList,
  [PipelineType.colourMatrix]: ConvertToColourMatrixUniformData
};
